// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"460":"370a2ea9","787":"d5fa4d18"}[chunkId] + ".chunk.js";
};